<template>
    <component :is="template">
        <div>
            <v-card tile elevation="0" class="overflow-auto">
                <div class="tit-wrap tit-wrap--unberline">
                    <h2 class="tit">eBook 열람</h2>
                </div>

                <div>

                    <v-data-table :items="ebooks" :headers="ebookHeaders" disable-pagination disable-sort mobile-breakpoint="768" hide-default-footer class="v-data-table--sm purchase-table">
                        <template v-slot:item.ebook="{item}">
                            <div class="px-8px py-12px px-md-10px py-md-16px">
                                <v-row align="center" class="row--small">
                                    <v-col cols="auto">
                                        <div class="pr-10px">
                                            <v-img :src="item?.product?.thumb" width="120" :aspect-ratio="1/1" contain class="border"/>
                                        </div>
                                    </v-col>
                                    <v-col cols="12" md="">
                                        <p class="font-size-16 font-weight-medium text-truncate">{{ item?.product?.name }}</p>
                                    </v-col>
                                </v-row>
                            </div>
                        </template>
                        <template v-slot:item.open="{ item }">
                            <v-btn v-if="!['반품요청', '반품완료'].includes(item.status)" small color="primary" class="white--text px-6px" @click="open(item)">보기</v-btn>
                        </template>
                    </v-data-table>
                </div>
            </v-card>

            <div class="mt-30px mt-md-40px">
                <v-pagination v-model="page" :length="pageCount" total-visible="11" @input="search(true)" />
            </div>
        </div>
    </component>
</template>

<script>
import api from "@/api";
export default {
    data(){
        return {
            filter: {},

            page: 1,
            pageCount: 0,
            limit: 10,
            ebookHeaders: [
                { text: "상품명", value: "ebook", align: "center" },
                { text: "열람", value: "open", align: "center", width: 100 },
            ]
        }
    },
    mounted(){
        if(this.logoff) this.$router.push(`/login`);
        this.init();
    },
    methods: {
        async init(){
            await this.search(false);
        },
        async search(routable = false){
            if(routable){
                this.$router.push({
                    query: { ...this.filter, page: this.page }
                });
            }

            let { summary, ebooks } = await api.v1.me.shop.ebooks.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit,
                },
                params: this.filter
            })
            this.ebooks = ebooks
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        },
        async open(ebook){
            if (ebook.ebookStatus === "미열람") {
                if (confirm("eBook을 열람하시겠습니까? \n열람시 취소가 불가능합니다.")) {
                    let { ebook: { ebookValue } } = await api.v1.me.shop.ebooks.get({ _id: ebook.product._id });
                    this.goWebviwer(ebookValue, this._user)
                }
            } else {
                let { ebook: { ebookValue } } = await api.v1.me.shop.ebooks.get({ _id: ebook.product._id });
                this.goWebviwer(ebookValue, this._user)
            }
        },
        async goWebviwer(ebookValue, uid) {
            // window.location.href = ebookValue + "?uid=" + uid
            let form = document.createElement("form");

            let obj = document.createElement("input");

            obj.setAttribute("name", "uid");

            obj.setAttribute("value", uid);

            form.appendChild(obj);

            form.setAttribute("method", "post");

            form.setAttribute("action", ebookValue);

            form.setAttribute("target", '_blank');

            document.body.appendChild(form);

            form.submit();
        }
    },
    computed: {
        template(){ return () => import(`@/templates/${this.$theme.pages.mypage}`) },
        payload() {
            return this.$store.state.payload;
        },
        _user() {
            return this.$store.state.payload._user;
        }
    }
}
</script>

<style scoped>
>>>.v-data-table--sm>.v-data-table__wrapper>table>tbody>tr>th, >>>.v-data-table--sm>.v-data-table__wrapper>table>tfoot>tr>th, >>>.v-data-table--sm>.v-data-table__wrapper>table>thead>tr>th, >>>.v-data-table--sm>.v-data-table__wrapper>table>tbody>tr>td, >>>.v-data-table--sm>.v-data-table__wrapper>table>tfoot>tr>td, >>>.v-data-table--sm>.v-data-table__wrapper>table>thead>tr>td{
    font-size:13px !important;
    padding:2px !important;
}
.v-data-table--sm .v-btn:not(.v-btn--round).v-size--x-small{
    min-width: auto;
    font-size: 13px;
    padding:0 4px;
}
</style>